export default __webpack_public_path__ + "static/challenge_img-17baf8baccd549721745ada66cd82af8.png";